export default function Error() {
  return (
    <h2>🥺 Oh no, something went wrong 🥺</h2>
  )
}
